const apigClientFactory = require('aws-api-gateway-client').default;

export function getApiClientFactor() {
    const apigClient = apigClientFactory.newClient({
        invokeUrl: 'https://endpoint.ivs-integ.last-mile.amazon.dev',
        region: 'us-east-1',
        accessKey: '',
        secretKey: ''
    });
    return apigClient;
}

export function getStationCode() {
    let params = new URLSearchParams(window.location.search);
    return params.get('stationCode');
}


// WEBPACK FOOTER //
// ./src/components/network/NetworkUtil.js